var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconThList = function SvgIconThList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15.75,
    viewBox: "0 0 18 15.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25,8.719v2.812a.844.844,0,0,1-.844.844H.844A.844.844,0,0,1,0,11.531V8.719a.844.844,0,0,1,.844-.844H4.406a.844.844,0,0,1,.844.844ZM0,14.344v2.812A.844.844,0,0,0,.844,18H4.406a.844.844,0,0,0,.844-.844V14.344a.844.844,0,0,0-.844-.844H.844A.844.844,0,0,0,0,14.344ZM4.406,2.25H.844A.844.844,0,0,0,0,3.094V5.906a.844.844,0,0,0,.844.844H4.406a.844.844,0,0,0,.844-.844V3.094a.844.844,0,0,0-.844-.844ZM7.219,18h9.937A.844.844,0,0,0,18,17.156V14.344a.844.844,0,0,0-.844-.844H7.219a.844.844,0,0,0-.844.844v2.812A.844.844,0,0,0,7.219,18ZM6.375,3.094V5.906a.844.844,0,0,0,.844.844h9.937A.844.844,0,0,0,18,5.906V3.094a.844.844,0,0,0-.844-.844H7.219A.844.844,0,0,0,6.375,3.094Zm.844,9.281h9.937A.844.844,0,0,0,18,11.531V8.719a.844.844,0,0,0-.844-.844H7.219a.844.844,0,0,0-.844.844v2.812A.844.844,0,0,0,7.219,12.375Z",
    transform: "translate(0 -2.25)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconThList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-th-list.dfe0b2b0.svg";
export { ForwardRef as ReactComponent };